<template>
  <div class="newsMain">
    <PcRep class="PC"/>
    <MdRep class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdRep from './MdRep.vue'
// pc端
import PcRep from './PcRep.vue'
export default {
  name: 'newsMain',
  components: {
    PcRep,
    MdRep
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsMain{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsMain{
    .MD{
      display: none;
    }
  }
}
</style>
